module.exports = __webpack_public_path__ + "img/charts.6252851a.png";